import Vue from 'vue';
import RoundButton from '@/components/form/RoundButton.vue';

Vue.component('RoundButton', RoundButton);
